module.exports = __webpack_public_path__ + "img/login_bottom_right.81fbcdda.png";